//const marketplaceUrl= 'https://marketplace-v2.buupass.com/marketplace/';
const marketplaceUrl= 'https://marketplaceapi.dev.buupass.com/marketplace/'
  //const v2P='https://pay-v2.buupass.com/payments/';
 const v2P='https://payments.dev.buupass.com/payments/';
 

  const marketplaceUrlTrips= 'https://easycoach.buupass.com/';
 const usersApi='https://usermanagementapi.dev.buupass.com/user-management/users/';
const usersApiLogin='https://usermanagementapi.dev.buupass.com/user-management/users/login';
  
export const environment = {
    //api_key:'Pt5BLUID.ntj1S2NQMJac0IbRV1IDF3XDLb8jwPDY',
    api_key:'35HQhHlP.XbSGhqMMq6H1AT4VV9pu497iIS0VpUEO',
    production: false,
    wsBaseUrl: 'wss://payments.dev.buupass.com/',
    getDestinations: marketplaceUrl+'buses/bms/website?request_call=aliases',
    searchBuses: marketplaceUrl+'buses/bms/website?request_call=schedules',
    scheduleOperatorContract: {
      // Keep disabled until Marketplace confirms the exact query field.
      enabled: false,
      queryParameter: '',
      serialization: 'csv' as 'csv' | 'repeat'
    },
    getSeats: marketplaceUrl + 'buses/seats',
    bookingApi: marketplaceUrl+'booking/',
    bookingApiV2: marketplaceUrl+'booking/',
    paymentOptionsApi: marketplaceUrl+'booking/payment-options',
    confirmApi:marketplaceUrl+'website/api_mpesa_query_status/',
    bookingCheckPayApi: marketplaceUrl + 'booking/pay',
    v2confirm: v2P+'c2b/transaction/status/',
    retrieveEmail: usersApi+'retrieve/',
    resetPassword: usersApi+'password-reset',
    codePass: usersApi + 'code-validate',
    updateCodePass: usersApi + 'password-reset/',
    signUp: usersApi+'registration',
    loginUser:usersApi+'login',
    getProfile: usersApi+'profile',
    updateProfile: usersApi+'profile',
    usersApiLogin:usersApiLogin,
    getTrips: marketplaceUrl+'booking/search?search=',
    whitelabelConfigApi: '/config/get',
    whitelabelConfigTimeoutMs: 8000,
    localWhitelabelConfig: '/assets/config/operator.dev.json',
    runtimeConfigUrl: '/assets/config/operator.dev.json'
};
